import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingRigSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 1h4v1h-.5L9 7h2v1H1V7h2l1.5-5H4V1Zm0 6h4L6.8 3H5.2L4 7Z"
    />
    <path d="M2.856 9H1.66L1 10v1h.539l1.317-2ZM4.558 11H3.361l1.317-2h1.198l-1.318 2ZM8.856 9H7.658l-1.317 2h1.197l1.318-2ZM11 9h-.362l-1.317 2h1.197l.482-.732V9Z" />
  </svg>
);
export default IconDrillingRigSizeXs;
